import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import Compliance_ae from '../childrens/compliance_ae/.mixins';

export default function AlertDialog(props) {
  return (
    <div>
      <Dialog
        open={props.state.openModel}
        onClose={props.handleCloseModel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Compliance_ae {...props}/>
      </Dialog>
    </div>
  );
}